import { getField, updateField } from 'vuex-map-fields'

const state = {
  criteria: [],
  selectedCriteria: null,
  score: {
    id: null,
    value: '',
    score: '',
    criteria: null,
    from: '',
    to: ''
  },
  scoreDescription: []
}

const getters = {
  getField,
  getSelectedCriteria () {
    return state.selectedCriteria
  }
}

const mutations = {
  updateField,
  setCriteria (state, criteria) {
    state.criteria = criteria
  },

  setSelectedCriteria (state, criteria) {
    state.selectedCriteria = criteria
  },

  changeCriteriaSelected (state, criteria) {
    state.criteria.map((item) => {
      if (item.id === criteria.id) {
        state.selectedCriteria = criteria
        state.score.criteria = criteria
        // eslint-disable-next-line no-return-assign
        return item.selected = true
      }
      // eslint-disable-next-line no-return-assign
      return item.selected = false
    })
  },

  changeCriteriaLabel (state, lang) {
    if (state.criteria.length > 0) {
      state.criteria.map((item) => {
        if (lang === 'en') {
          // eslint-disable-next-line no-return-assign
          return item.name = item.name_en
        } else {
          // eslint-disable-next-line no-return-assign
          return item.name = item.name_km
        }
      })
    }
  },

  updateFormDataTo (state, to) {
    state.score.to = to
  },
  updateFormDataFrom (state, from) {
    state.score.from = from
  },
  updateFormDataScore (state, score) {
    state.score.score = score
  },
  updateFormDataValue (state, value) {
    state.score.value = value
  },
  updateFormDataCriteria (state, criteria) {
    state.score.criteria = criteria
  },
  resetScoreState (state) {
    state.score = {
      id: null,
      value: '',
      score: '',
      criteria: null,
      from: '',
      to: ''
    }
  },
  setFormDataScore (state, score) {
    state.score = {
      id: score.id,
      value: score.value_string !== null ? score.value_string : score.value_reference_id,
      score: score.score,
      criteria: score.scoring_criteria,
      from: score.value_number_primary,
      to: score.value_number_secondary
    }
  },
  setScoreDescription (state, scoreDesc) {
    state.scoreDescription = scoreDesc
  }
}

const actions = {
  setCriteria ({ commit, status }, criteria) {
    commit('setCriteria', criteria)
  },
  setSelectedCriteria ({ commit, status }, criteria) {
    commit('setSelectedCriteria', criteria)
  },
  changeCriteriaSelected ({ commit, status }, criteria) {
    commit('changeCriteriaSelected', criteria)
  },
  changeCriteriaLabel ({ commit, status }, lang) {
    commit('changeCriteriaLabel', lang)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
